import { useMutation } from '@tanstack/react-query';
import { Button, Descriptions, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { usePostApi } from 'hooks/api';

import apiCall from 'apps/futureflex/apiCalls/employeeProgramOrder';
import {
  orderTypeColors,
  orderTypeLabels,
} from 'apps/investment/constants/fundOrder';
import {
  orderSideColors,
  orderSideLabels,
  programOrderMatchSourceCompanyPortfolio,
  programOrderMatchSourceFundManager,
  programOrderStatusColors,
} from 'apps/investment/constants/programOrder';
import { formatNumberOrDash } from 'utils/formatAmount';
import { formatDateTime } from 'utils/formatDate';
import { FundOrderAction } from './PostActions';

const ItemDetail = ({ item, onRefresh }) => {
  const { employee, employee_program, company, order, ...data } = item || {};

  const {
    id,
    code,
    company_id,
    employee_id,
    status,
    status_label,
    order_type,
    product_code,
    order_side,
    estimate_quantity,
    quantity,
    matched_source,
    company_investment_detail_id,
    employee_investment_detail_id,
    order_date,
  } = data;

  const {
    post: cancelOrder,
    isLoading: isCancelling,
    error: cancelOrderError,
  } = usePostApi(apiCall.cancel, { onSuccess: () => onRefresh?.() });

  const { name: companyName } = company || {};
  const { full_name: employeeName } = employee || {};
  const { product_id } = order || {};

  return (
    <>
      <Descriptions
        title="Order detail"
        bordered
        column={1}
        extra={
          <>
            <Button
              disabled={isCancelling}
              onClick={() => {
                let warningMessage = `Are you sure you want to cancel the program order ${item.code}? Enter order code to confirm: ${item.code}`;
                let confirmCode = prompt(warningMessage);

                if (confirmCode == item.code) {
                  cancelOrder({ id: item.id });
                  return;
                } else {
                  alert('program order code was not match');
                }
              }}
              type="primary"
              style={{
                margin: 10,
                backgroundColor: 'red',
                borderColor: 'red',
              }}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Descriptions.Item label={'ID'}>{id}</Descriptions.Item>
        <Descriptions.Item label={'Status'}>
          <Tag color={programOrderStatusColors[status]}>{status_label}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label={'Order Type'}>
          <Tag color={orderTypeColors[order_type]}>
            {orderTypeLabels[order_type]
              ? orderTypeLabels[order_type]
              : order_type}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label={'Matched source'}>
          {matched_source === programOrderMatchSourceCompanyPortfolio
            ? 'Quỹ tái phân phối'
            : matched_source === programOrderMatchSourceFundManager
            ? 'Giao dịch'
            : matched_source}
        </Descriptions.Item>
        <Descriptions.Item label={'Order Side'}>
          <Tag color={orderSideColors[order_side]}>
            {orderSideLabels[order_side]}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label={'Interval'}>
          {item.interval}
        </Descriptions.Item>

        <Descriptions.Item label={'Amount'}>
          {formatNumberOrDash(item.amount)}
        </Descriptions.Item>

        <Descriptions.Item label={'Quantity'}>
          {formatNumberOrDash(item.quantity)}
        </Descriptions.Item>

        <Descriptions.Item label={'Matched Price'}>
          {formatNumberOrDash(item.matched_price)}
        </Descriptions.Item>

        <Descriptions.Item label={'Estimated Quantity'}>
          {formatNumberOrDash(item.estimate_quantity)}
        </Descriptions.Item>

        <Descriptions.Item label={'Fund Order'}>
          {order ? (
            <Link to={`/investment/fund-orders/${order.id}`}>
              View Fund Order {order.id}
            </Link>
          ) : (
            'Not created yet'
          )}
        </Descriptions.Item>

        <Descriptions.Item label={'Product Code'}>
          <Link to={`/investment/products/${item.product.id}`}>
            {item.product.code}
          </Link>
        </Descriptions.Item>

        <Descriptions.Item label={'Company investment detail'}>
          {company_investment_detail_id}
        </Descriptions.Item>
        <Descriptions.Item label={'Employee investment detail'}>
          {employee_investment_detail_id}
        </Descriptions.Item>

        <Descriptions.Item label={'Company'}>
          <Link to={`/futureflex/companies/${company_id}`}>{companyName}</Link>
        </Descriptions.Item>
        <Descriptions.Item label={'Employee'}>
          <Link to={`/futureflex/employees/${employee_id}`}>
            {employeeName}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label={'Employee Program'}>
          <Link to={`/futureflex/employee-programs/${employee_program.id}`}>
            View program
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="Order Date">
          {formatDateTime(order_date, 'DD/MM/YYYY')}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDateTime(item.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDateTime(item.updated_at)}
        </Descriptions.Item>
        <Descriptions.Item label={'Action'}>
          <FundOrderAction order={order} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default ItemDetail;
